import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: "100%",
    position: "relative",
  },

  title_container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  snackbar_container: {
    left: "45%",
    top: "100px",
    position: "fixed",
    zIndex: 100,
  },

  positionBase: {
    position: "static",
  },
  snippetContainer: {
    marginTop: 24,
  },
  noteContainer: {
    marginTop: 40,
    [theme.breakpoints.down("desktop")]: {
      marginTop: 24,
    },
  },
  content: {
    width: "100%",
    marginTop: 24,
    display: "flex",
    justifyContent: "space-between",
    [theme.breakpoints.down("desktop")]: {
      flexDirection: "column",
    },
  },
  leftSide: {
    width: 320,
    [theme.breakpoints.down("desktop")]: {
      width: "100%",
    },
  },
  rightSide: {
    width: "62%",
    maxWidth: 580,
    [theme.breakpoints.down("desktop")]: {
      width: "100%",
      marginTop: 24,
      maxWidth: "100%",
    },
  },
  inputContainer: {
    width: "100%",
    display: "grid",
  },
  dateContainer: {
    marginTop: 14,
  },
  inputTopMargin: {
    marginTop: 37,
  },
  footer: {
    width: "100%",
    marginTop: 56,
    [theme.breakpoints.down("desktop")]: {
      marginTop: 40,
    },
  },
}));

export default useStyles;
